<!-- material-certificate.component.html -->
<div>
  <div class="row">
    <div class="col-md-4" *ngFor="let certType of certificationTypes; let i = index">
      <div class="certification-section">
        <label>{{ certType.label }}</label>
        <div class="certification-options" *ngIf="!certType.isAdditional">
          <button
            class="btn-option"
            *ngFor="let option of certType.options; trackBy: trackByFn"
            [class.active]="certType.selected === option"
            (click)="selectOption(certType, option, false)"
          >
            {{ option }}
          </button>
          <div
            class="custom-input"
            [class.carbon-input]="certType.id === CertificateType.CARBON"
            *ngIf="certType.selected === certType.customOption"
          >
            <input
              #customInput
              [attr.data-type-id]="certType.id"
              type="text"
              [(ngModel)]="certType.customValue"
              placeholder="Enter custom certification"
              (blur)="selectOption(certType, certType.customOption, true)"
            />
            <div class="input-error" *ngIf="certType.error">
              {{ certType.error }}
            </div>
          </div>
        </div>
        <div class="custom-input" *ngIf="certType.isAdditional">
          <input
            type="text"
            [(ngModel)]="certType.customValue"
            placeholder="Enter certification name"
            (blur)="onAdditionalCertificationInput(certType)"
          />
          <div class="input-error" *ngIf="certType.error">
            {{ certType.error }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
